import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, Ship, Users, LogOut } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function AppShell({ children }) {
  const location = useLocation();
  const nav = useNavigate();
  const { user, logout } = useAuth();

  const hideNav = location.pathname === "/login";

  return (
    <div className="min-h-screen bg-[#FBFAF9] flex flex-col">
      {!hideNav && (
        <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-xl border-b border-stone-200">
          <div className="w-full max-w-2xl mx-auto px-5 h-14 flex items-center justify-between">
            <div
              className="flex items-center cursor-pointer"
              onClick={() => nav("/app")}
              data-testid="brand-home"
            >
              <img src="/traderepubliq-logo.svg" alt="TradeRepubliq" className="h-7" />
            </div>
            <button
              onClick={() => { logout(); nav("/"); }}
              className="text-stone-500 hover:text-[#6B0F1A] p-2 rounded-lg hover:bg-stone-100"
              data-testid="logout-btn"
              title={user?.email}
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </header>
      )}

      <main className="flex-1 w-full max-w-2xl mx-auto pb-24 fade-up">
        {children}
      </main>

      {!hideNav && (
        <nav
          className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-xl border-t border-stone-200 pb-safe z-50"
          data-testid="bottom-nav"
        >
          <div className="w-full max-w-2xl mx-auto flex items-stretch justify-around">
            <NavItem to="/app" icon={<LayoutDashboard className="w-5 h-5" />} label="Dashboard" testId="nav-dashboard" end />
            <NavItem to="/app/shipments" icon={<Ship className="w-5 h-5" />} label="Shipments" testId="nav-shipments" />
            {user?.role !== "buyer" && (
              <NavItem to="/app/buyers" icon={<Users className="w-5 h-5" />} label="Buyers" testId="nav-buyers" />
            )}
          </div>
        </nav>
      )}
    </div>
  );
}

function NavItem({ to, icon, label, testId, end }) {
  return (
    <NavLink
      to={to}
      end={end}
      data-testid={testId}
      className={({ isActive }) =>
        `flex-1 flex flex-col items-center justify-center py-2.5 text-xs font-semibold transition-colors ${
          isActive ? "text-[#6B0F1A]" : "text-stone-400 hover:text-stone-600"
        }`
      }
    >
      {icon}
      <span className="mt-0.5">{label}</span>
    </NavLink>
  );
}
